<ng-container *transloco="let t">
    <ng-container *ngIf="flyoutKey && $any(t(flyoutKey)) as items">
        <mat-card
            appearance="outlined"
            class="sub-title-tooltip"
            [ngClass]="{
                display: active,
                'flip-up': flipUp
            }"
            *ngIf="items[0]?.header"
        >
            <mat-card-content>
                <ng-container *ngFor="let item of items">
                    <h3>{{ item.header }}</h3>
                    <p>{{ item.text }}</p>
                </ng-container>
            </mat-card-content>
        </mat-card>
    </ng-container>
</ng-container>
